/** Giriş ekranı personel listesi değişince (engel / engel kaldırma) diğer sekmeleri bilgilendirir. */
export const LOGIN_LIST_BROADCAST_CHANNEL = "parkbakim_login_list";

export function notifyLoginListMaybeChanged() {
  try {
    if (typeof BroadcastChannel === "undefined") return;
    const ch = new BroadcastChannel(LOGIN_LIST_BROADCAST_CHANNEL);
    ch.postMessage({ type: "personnel_login_list_changed" });
    ch.close();
  } catch {
    /* ignore */
  }
}
